import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { PolicyPipesModule } from '@amfam/policy/pipes';
import { PolicyVehicleCoveragesDataAccessModule } from '@amfam/policy/vehicle-coverages/data-access';
import { DsRouterLinkModule } from '@amfam/shared/ui/ds-router-link';
import { PipesModule } from '@amfam/shared/ui/pipes';
import { RiskListModule } from '@amfam/shared/ui/risk-list';
import { BrandDirectivesModule } from '@amfam/shared/utility/brand';
import { ImpersonationModule } from '@amfam/shared/utility/impersonation';
import { SharedServicesModule } from '@amfam/shared/utility/shared-services';
import { UiKitModule } from '@amfam/ui-kit';

import { CoveragesInfoComponent } from './coverages-page/coverages-info/coverages-info.component';
import { PremiumCostComponent } from './coverages-page/premium-cost/premium-cost.component';
import { RecalculateSidebarComponent } from './coverages-page/recalculate-sidebar/recalculate-sidebar.component';

@NgModule({
  imports: [
    CommonModule,
    UiKitModule,
    SharedServicesModule,
    RouterModule,
    PipesModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    ImpersonationModule,
    DsRouterLinkModule,
    BrandDirectivesModule,
    PolicyPipesModule,
    RiskListModule,
    PolicyVehicleCoveragesDataAccessModule
  ],
  declarations: [CoveragesInfoComponent, RecalculateSidebarComponent, PremiumCostComponent],
  exports: [CoveragesInfoComponent, RecalculateSidebarComponent, PremiumCostComponent]
})
export class PolicyChangeCoverageUiModule {}
